import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals'

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    try { getCLS(onPerfEntry) } catch (_) {}
    try { getFID(onPerfEntry) } catch (_) {}
    try { getFCP(onPerfEntry) } catch (_) {}
    try { getLCP(onPerfEntry) } catch (_) {}
    try { getTTFB(onPerfEntry) } catch (_) {}
  }
}

export default reportWebVitals
